import React, { useEffect, useRef, useState } from "react"
import Img from "gatsby-image"

import styles from "../styles/home.module.css"
import apple from "../assets/images/apple-app-store.svg"
import android from "../assets/images/google-play-badge.png"

export default function Home({ imgs }) {
  const [imgLoaded, setImgLoaded] = useState(false)
  const imgRef = useRef(null)
  const contentRef = useRef(null)

  useEffect(() => {
    if (imgLoaded || window.innerWidth <= 768) {
      imgRef.current.className = [imgRef.current.className, styles.loaded].join(
        " "
      )

      contentRef.current.className = [
        contentRef.current.className,
        styles.loaded,
      ].join(" ")
    }

  }, [imgLoaded])



  return (
    <section className={styles.container}>
      <div ref={contentRef} className={[styles.content, styles.text].join(" ")}>
        <h1 className={styles.title}>Earn Your Guilty Pleasures</h1>
        <h4 className={styles.subText}>
          Built to motivate you <span className={styles.highlight}>to do</span> &{" "}
          <span className={styles.highlight}>to be</span> through the power of{" "}
          <span className={styles.highlight}>ta da</span>
        </h4>
        <div className={styles.row}>
          <img src={apple} alt="Apple App Store" />
          <img
            src={android}
            alt="Google Play Store"
            style={{ width: "180px" }}
          />
        </div>
      </div>
      <div ref={imgRef} className={[styles.content, styles.img].join(" ")}>
        {imgs.map((img, i) => (
          <Img
            key={i}
            onLoad={() => setImgLoaded(true)}
            fixed={img.node.childImageSharp.fixed}
            className={i === 0 ? styles.bg : {}}
          />
        ))}
      </div>
    </section>
  )
}
